<div class="text-center w-100 p-5">
	<fa-icon [icon]="['fas', 'spinner']" size="2x" [spin]="true" class="mr-2 text-muted"></fa-icon>
	<span>{{ message }}</span>
</div>
